export default class ManagerRequests {
	static requests = [];

	static addRequest(obj) {
		const findRequest = this.findRequest(obj.key, obj.value);

		if (!findRequest) {
			obj.status = 'INPROGRESS';
			this.requests.push(obj);
		}
	}

	static findRequest(key, value) {
		return this.requests.find(request => request.key === key && request.value === value);
	}

	static resolveRequest(key, value, response) {
		const findRequest = this.findRequest(key, value);
		findRequest.status = "RESOLVED";
		findRequest.response = response;
	}

	static getRequests() {
		return this.requests;
	}

	static updateRequestEntityFileLocks(key, value, lock) {
		this.requests.map((request) => {
			if(request.key === key && request.value === value) {
				request.response.entity.locks.push(lock);
			}
		});
	}

	static updateRequestRemoveFileLocks(key, value, type) {
		this.requests.map((request) => {
			if(request.key === key && request.value === value) {

				const locks = request.response.entity.locks;
				locks.forEach((lock, id) => {
					if(lock.action === type) {
						locks.splice(id, 1)
					}
				});
				
				request.response.entity.locks = locks;
			}
		});
	}

}
